export const FETCH_ORDER = 'FETCH_ORDER'
export const PLACE_ORDER = 'PLACE_ORDER'